export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7589.76a5440b.jpg";